import * as React from 'react';
import {
    Create,
    SimpleForm,
    TextInput,
    SelectInput,
    SaveButton,
    Toolbar,
    TopToolbar,
    required,
    useTranslate,
} from 'react-admin';
import { Link } from 'react-router-dom';
import { useWatch } from 'react-hook-form';
import { Grid, Typography, Stack, Button } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import VpnKeyOutlinedIcon from '@mui/icons-material/VpnKeyOutlined';
import InfoSchemaForm, {
    getOAuthBasicAuthFields,
} from '../../components/InfoSchemaForm';
import UserSearchWidget from '../../components/UserSearchWidget';

const USER_GUID_WIDGETS = { UserSearchWidget };
const USER_GUID_UI_SCHEMA = {
    user_guid: { 'ui:widget': 'UserSearchWidget' },
};

const TYPE_CHOICES = [
    { id: 'openid', name: 'OpenID' },
    { id: 'apikey', name: 'API Key' },
];

const CreateActions = () => {
    const translate = useTranslate();
    return (
        <TopToolbar>
            <Button
                startIcon={<ArrowBackIcon />}
                component={Link}
                to="/hallinta?tab=5"
                size="small"
            >
                {translate('hallinta.oauth_clients.actions.back')}
            </Button>
        </TopToolbar>
    );
};

const CreateToolbar = () => (
    <Toolbar>
        <SaveButton />
    </Toolbar>
);

const InfoConfigSections = () => {
    const translate = useTranslate();
    const type = useWatch({ name: 'type' });
    if (!type) return null;
    const basicAuthFields = getOAuthBasicAuthFields(type);
    return (
        <>
            <Typography variant="h6" gutterBottom>
                {translate('hallinta.oauth_clients.sections.info_config')}
            </Typography>
            <InfoSchemaForm
                key={type}
                resource="oauth-client"
                type={type}
                source="info"
                exclude={basicAuthFields}
            />
            <Stack
                direction="row"
                alignItems="center"
                spacing={1}
                sx={{ mt: 3, mb: 1 }}
            >
                <VpnKeyOutlinedIcon fontSize="small" sx={{ color: 'black' }} />
                <Typography variant="h6" sx={{ mb: 0 }}>
                    {translate('hallinta.oauth_clients.sections.basic_auth')}
                </Typography>
            </Stack>
            <InfoSchemaForm
                key={`${type}-basic-auth`}
                resource="oauth-client"
                type={type}
                source="info"
                include={basicAuthFields}
                widgets={USER_GUID_WIDGETS}
                uiSchema={USER_GUID_UI_SCHEMA}
            />
        </>
    );
};

const OAuthClientCreate = () => {
    const translate = useTranslate();

    return (
        <Create
            resource="admin/oauth-clients"
            redirect="edit"
            actions={<CreateActions />}
        >
            <SimpleForm toolbar={<CreateToolbar />}>
                <Grid container spacing={3}>
                    <Grid size={{ xs: 12, md: 5 }}>
                        <Typography variant="h6" gutterBottom>
                            {translate(
                                'hallinta.oauth_clients.tabs.basic_info'
                            )}
                        </Typography>
                        <Stack spacing={1}>
                            <TextInput
                                source="name"
                                label={translate(
                                    'hallinta.oauth_clients.fields.name'
                                )}
                                validate={[required()]}
                                fullWidth
                            />
                            <SelectInput
                                source="type"
                                label={translate(
                                    'hallinta.oauth_clients.fields.type'
                                )}
                                choices={TYPE_CHOICES}
                                validate={[required()]}
                                defaultValue="openid"
                                fullWidth
                            />
                        </Stack>
                    </Grid>
                    <Grid size={{ xs: 12, md: 7 }}>
                        <InfoConfigSections />
                    </Grid>
                </Grid>
            </SimpleForm>
        </Create>
    );
};

export default OAuthClientCreate;
